// Utils & misc
import cn from '../../../utils/cn';

// Components

// Style
import styles from './NavigationMenu.module.css';

/**
 *
 * @param {object} params
 * @param {string} params.className
 * @param {React.ReactNode} params.children
 * @param {boolean} params.isOpen
 * @returns {React.ReactNode}
 */
function NavigationMenu({
  isOpen, className, children,
}) {
  return (
    <nav
      className={cn([
        styles['navigation-menu'],
        className,
        isOpen && styles['navigation-menu-open'],
        !isOpen && styles['navigation-menu-close'],
      ])}
    >
      <div className={styles['navigation-menu-content']}>
        {children}
      </div>
    </nav>
  );
}

/**
 * NavigationMenuGroup component - A group of navigation menu items
 * @param {object} params
 * @param {React.ReactNode} params.children
 * @param {'none' | 'xs' | 's' | 'm'} [params.gap = 'none'] - Gap between menu items
 * @returns {React.ReactNode}
 */
export function NavigationMenuGroup({
  children,
  gap = 'none',
}) {
  return <div className={cn([styles['navigation-menu-group'], styles[gap]])}>{children}</div>;
}

/**
 * NavigationLogo component - A logo for the navigation menu
 * @param {object} params
 * @param {React.ReactNode} params.children
 * @returns {React.ReactNode}
 */
export function NavigationLogo({ children }) {
  return (
    <div className={styles['navigation-menu-logo']}>
      {children}
    </div>
  );
}

export default NavigationMenu;
